import { render } from "./SalaryType.vue?vue&type=template&id=7e83bff4&scoped=true"
import script from "./SalaryType.vue?vue&type=script&lang=js"
export * from "./SalaryType.vue?vue&type=script&lang=js"

import "./SalaryType.vue?vue&type=style&index=0&id=7e83bff4&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e83bff4"]])

export default __exports__